import { render } from "./professionals-sales-workshop-form.vue?vue&type=template&id=234d2ba8&scoped=true"
import script from "./professionals-sales-workshop-form.vue?vue&type=script&lang=js"
export * from "./professionals-sales-workshop-form.vue?vue&type=script&lang=js"

import "./professionals-sales-workshop-form.vue?vue&type=style&index=0&id=234d2ba8&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-234d2ba8"]])

export default __exports__